import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-gray-800">
      <h2 className="text-4xl font-bold text-black">
            Terms &<span className="text-red-900"> Conditions</span>
          </h2>

      <p className="mb-4">
        These Terms and Conditions ("Terms") govern your use of the Solar Ark website and services. By accessing our site or using our services, you agree to these Terms in full.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2 text-red-900">1. Services</h2>
      <p className="mb-4">
        Solar Ark provides solar energy consultation, installation, and maintenance services. All services are subject to availability and a formal agreement.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2 text-red-900">2. User Responsibilities</h2>
      <p className="mb-4">
        You agree to provide accurate information, follow guidelines provided by our team, and comply with local laws regarding energy usage and installations.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2 text-red-900">3. Payments</h2>
      <p className="mb-4">
        All payments must be made as per the invoicing terms. Delayed or failed payments may result in service suspension or cancellation.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2 text-red-900">4. Intellectual Property</h2>
      <p className="mb-4">
        All content on this website, including logos, images, text, and software, is the property of Solar Ark and may not be reused without written permission.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2 text-red-900">5. Cancellations & Refunds</h2>
      <p className="mb-4">
        Cancellations must be made in writing. Refunds, if applicable, will be processed according to the terms in your signed service agreement.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2 text-red-900">6. Limitation of Liability</h2>
      <p className="mb-4">
        Solar Ark shall not be liable for indirect, incidental, or consequential damages arising from use or inability to use the services.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2 text-red-900">7. Governing Law</h2>
      <p className="mb-4">
        These Terms are governed by and construed in accordance with the laws of India. Any disputes shall be handled by the appropriate courts of Maharashtra.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2 text-red-900">8. Changes to Terms</h2>
      <p className="mb-4">
        We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to the website.
      </p>

      <p className="mt-8 text-sm text-gray-600">Last Updated: July 28, 2025</p>
    </div>
  );
};

export default TermsAndConditions;
